export default __webpack_public_path__ + "static/media/cigar.b8fb1d3c.jpg";